import script from "./CommercialOfferSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommercialOfferSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./CommercialOfferSettingsDialog.vue?vue&type=style&index=0&id=975bbb56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-975bbb56"]])

export default __exports__